import { Title, Text, Button, Group, Image } from '@mantine/core';
import { Link } from "react-router-dom"

function CustomComponent() {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <div>
        <Image
          src="/logo.png" // Replace with your logo path
          w={120}
          h="auto"
          m="0 auto"
          alt="Logo"
        />
        <Title order={3} align="center" mt="md" mb="sm">
          Emme Negocios
        </Title>

        <Text size="sm" align="center" mb={50}>
          Punto de venta y gestión de negocio
        </Text>


          <Link to="/auth/signup">
            <Group position="center" mt="md" mb="xs">
              <Button radius="xl" size="md" style={{ flex: 1 }}>
                Regístrate
              </Button>
            </Group>
          </Link>

          <Link to="/auth/signin">
            <Group position="center">
              <Button variant="outline" radius="xl" size="md" style={{ flex: 1 }}>
                Iniciar Sesión
              </Button>
            </Group>
          </Link>
      </div>
    </div >

  );
}

export default CustomComponent;
